exports.components = {
  "component---node-modules-smooth-doc-src-templates-doc-js": () => import("./../../../node_modules/smooth-doc/src/templates/doc.js" /* webpackChunkName: "component---node-modules-smooth-doc-src-templates-doc-js" */),
  "component---node-modules-smooth-doc-src-templates-page-js": () => import("./../../../node_modules/smooth-doc/src/templates/page.js" /* webpackChunkName: "component---node-modules-smooth-doc-src-templates-page-js" */)
}

